import { createSlice } from "@reduxjs/toolkit";

const deviceList = createSlice({
    name: "Device List",
    initialState: {
        devices: [],
        globalSearchNode: false,
        reRenderTreeUponSearch: Date.now() // This is used to re-render the tree when a search is performed
    },
    reducers: {
        appendDevices: (state, action) => {
            state.devices.push(action.payload)
        },

        clearDeviceList: (state) => {
            state.devices = []
        },

        appendGlobalSearchNode: (state, action) => {
            state.globalSearchNode = action.payload;
        },

        setReRenderTreeUponSearch: (state) => {
            state.reRenderTreeUponSearch = Date.now();
        }
    }
});

export const { appendDevices, clearDeviceList, appendGlobalSearchNode, setReRenderTreeUponSearch } = deviceList.actions;

export default deviceList.reducer;